function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.395 7.352c-.134.113-1.658 2.07-2.43 3.025a5.455 5.455 0 004.93.067c-.75-.925-2.346-2.976-2.484-3.092h-.016z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 5.5c0 1.255.427 2.41 1.137 3.335.672-.44 2.348-1.634 3.01-3.031 0 0-.95-.797-.996-1.998-.044-1.202 1.018-2.75 2.17-2.736.024 0 .05.003.074.005h.016c.025-.002.05-.005.074-.005 1.152-.015 2.214 1.534 2.17 2.736-.046 1.201-.996 1.998-.996 1.998.711 1.5 2.592 2.768 3.142 3.116A5.47 5.47 0 0011 5.5C11 2.469 8.533 0 5.5 0A5.507 5.507 0 000 5.5z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.42 2.122h-.031c-.221 0-.836-.06-.689.578.147.638.68 1.43.68 1.43.024.039.046 0 .046 0s.535-.792.68-1.43c.124-.537-.29-.58-.556-.58l-.13.002z",
  fill: "url(#paint2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 5.431,
  y1: -3.076,
  x2: 5.431,
  y2: 18.894,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC810"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.055,
  stopColor: "#FFC810"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F89521"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 5.5,
  y1: -3.076,
  x2: 5.5,
  y2: 18.894,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC810"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.055,
  stopColor: "#FFC810"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F89521"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 5.403,
  y1: -3.076,
  x2: 5.403,
  y2: 18.892,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC810"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.055,
  stopColor: "#FFC810"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F89521"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11v11H0z"
})));

var SvgCharity = function SvgCharity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCharity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/charity.22b35eb3.svg";
export { ForwardRef as ReactComponent };